import Spinner from 'components/spinner/spinner.component';
import { usePreload } from './client.hooks';

const Preload = ({ children }) => {
  const { loadingData } = usePreload();

  return loadingData ? <Spinner /> : <>{children}</>;
};
export default Preload;
